import { Components, Theme } from '@mui/material/styles';
import { TabComponent } from './Tab';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export const flowTab: Components<Theme>['MuiTab'] = {
  defaultProps: {
    disableRipple: true,
    iconPosition: 'start',
    // duplicate labels so we can change font-weight without increasing width
    component: TabComponent,
    LinkComponent: (props) => <TabComponent link {...props} />,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      position: 'relative',
      overflow: 'visible',
      // proportions
      padding: '8px 8px',
      minHeight: '0',
      minWidth: '0',
      // space between label and icon
      gap: '8px',
      // make sure there is space for focused boxShadow
      margin: '2px 2px 10px',
      // style
      borderRadius: '4px',
      // custom font style according to design
      fontSize: '20px',
      textTransform: 'none',
      fontWeight: '400',
      // colors and effects
      color: theme.palette.text.primary,
      '&:hover, &.Mui-focusVisible': {
        // hide regular label
        '& .FlowTab-label': {
          display: 'none',
        },
        // show selected label with bolder font
        '& .FlowTab-selectedLabel': {
          opacity: '1',
        },
      },
      // icon in tab
      ...(ownerState.icon && {
        // prevent icon from jumping between switching font weights
        ...(ownerState.iconPosition === 'start' && {
          // expand from left
          '& .FlowTab-label': {
            left: '0',
          },
        }),
        ...(ownerState.iconPosition === 'end' && {
          // expand from right
          '& .FlowTab-label': {
            right: '0',
          },
        }),
      }),
      // active
      '&.Mui-selected': {
        color: theme.palette.text.primary,
        fontWeight: '700',
        // hide regular label
        '& .FlowTab-label': {
          display: 'none',
        },
        // show selected label with bolder font
        '& .FlowTab-selectedLabel': {
          opacity: '1',
        },
      },
      // disabled
      '&.Mui-disabled': {
        color: theme.palette.disabled.tertiary,
      },
      // focused style
      ...getFocusRingStyle(theme, false, '2px'),
      // responsive
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
        marginBottom: '10px',
      },
    }),
  },
};
